import React, { ReactNode } from "react";
import { Accordion, Card, useAccordionButton } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "../assets/css/Sidebar.css";
import { IMenuItem } from "./";

interface ISidebarItem {
    ekey: string,
    icon: ReactNode,
    label: string,
    items?: IMenuItem[],
    onClick?: () => Promise<void>,
    onNavigate: string | null,
    isSmall?: boolean,
}

export const SidebarItem: React.FC<ISidebarItem> = ({ ekey, icon, label, items, onClick, onNavigate, isSmall }) => {
    const navigate = useNavigate();

    const textColor = !isSmall ? "text-white" : "";

    const CustomToggle = ({ children, eventKey }) => {
        const decoratedOnClick = useAccordionButton(eventKey, () => { });

        return (
            <span className={`nav-link ${textColor} fs-6`} onClick={decoratedOnClick}>
                {children}
            </span>
        );
    };

    const handleOnClick = () => {
        if (onClick) {
            onClick();
        } else {
            navigate(onNavigate || (items[0]?.destiny || "/"));
        }
    };

    return (
        <Card className={!isSmall ? `bg-dark border-none` : ``} style={{ marginBottom: 10 }} onClick={() => onclick ? navigate(onclick) : null}>
            <Card.Header className="ds-sidebar-header"
                onClick={!(items && items?.length > 0) ? handleOnClick : null}
            >
                <CustomToggle eventKey={ekey}>
                    {icon}
                    <span className={`ms-2 ${!isSmall ? `d-none d-md-inline` : ``}`} style={{ cursor: "pointer" }}>{label}</span>
                </CustomToggle>
            </Card.Header>
            <Accordion.Collapse eventKey={ekey}>
                <>
                    {items?.map((i) => (
                        <Card.Body
                            key={i.key}
                            className="py-2 ds-sidebar-item"
                            onClick={() => handleOnClick()}
                        >
                            <span className={`nav-link ${textColor} fs-6`} style={{ cursor: "pointer" }}>
                                {!isSmall ? i.icon : null}
                                <span className={!isSmall ? `d-none d-md-inline` : ``}>{i.label}</span>
                            </span>
                        </Card.Body>
                    ))}
                </>
            </Accordion.Collapse>
        </Card >
    );
}
